import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgressbar } from 'react-circular-progressbar';
import { MdCheckCircle, MdError, MdLink, MdVideocam } from 'react-icons/md';
import { FaTrashAlt } from "react-icons/fa";
import { Grid, Typography, IconButton, Card, Box } from '@material-ui/core';

import 'react-circular-progressbar/dist/styles.css';

const VideoPreview = ({ files, onDelete }) => {
    // Como esse fluxo aceita estritamente apenas 1 vídeo, pegamos o primeiro item do array
    const uploadedFile = files[0];

    if (!uploadedFile) return null;

    const {
        id,
        preview,
        progress,
        uploaded,
        error,
        url,
        readableSize,
        file
    } = uploadedFile;

    // Obtém o nome do arquivo se ele existir localmente, ou extrai da URL salva
    const fileName = file?.name || (url ? url.substring(url.lastIndexOf('/') + 1) : 'video_produto.mp4');

    return (
        <Box style={{ marginTop: '20px', width: '100%' }}>
            <Card variant="outlined" style={{ padding: '12px', backgroundColor: '#fdfdfd' }}>
                <Grid container spacing={2} alignItems="center">
                    
                    {/* 1. MINIATURA / PREVIEW DO VÍDEO */}
                    <Grid item>
                        <Box 
                            style={{ 
                                width: '80px', 
                                height: '80px', 
                                borderRadius: '4px', 
                                overflow: 'hidden', 
                                backgroundColor: '#000',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0px 2px 4px rgba(0,0,0,0.1)'
                            }}
                        >
                            {preview ? (
                                <video
                                    src={preview}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    muted
                                    playsInline
                                    loop
                                    autoPlay
                                />
                            ) : (
                                <MdVideocam size={32} color="#fff" />
                            )}
                        </Box>
                    </Grid>

                    {/* 2. INFORMAÇÕES DO ARQUIVO */}
                    <Grid item xs style={{ minWidth: 0 }}>
                        <Typography 
                            variant="subtitle2" 
                            style={{ 
                                fontWeight: 600, 
                                color: '#333',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {fileName}
                        </Typography>
                        {readableSize && (
                            <Typography variant="caption" style={{ color: '#777', display: 'block' }}>
                                {readableSize}
                            </Typography>
                        )}
                        
                        {/* Mensagens de status contextuais */}
                        {error && (
                            <Typography variant="caption" style={{ color: '#e57878', fontWeight: 500 }}>
                                Falha no envio do vídeo.
                            </Typography>
                        )}
                        {!uploaded && !error && (
                            <Typography variant="caption" style={{ color: '#356C7C', fontWeight: 500 }}>
                                Enviando arquivo...
                            </Typography>
                        )}
                        {uploaded && !error && (
                            <Typography variant="caption" style={{ color: '#2e7d32', fontWeight: 500 }}>
                                Vídeo pronto e salvo.
                            </Typography>
                        )}
                    </Grid>

                    {/* 3. CONTROLES E STATUS DE PROGRESSO */}
                    <Grid item>
                        <Box display="flex" alignItems="center" gridGap="8px" style={{ gap: '8px' }}>
                            
                            {/* Indicador de progresso circular ativo durante o upload */}
                            {!uploaded && !error && (
                                <CircularProgressbar
                                    styles={{
                                        root: { width: 28 },
                                        path: { stroke: '#356C7C' },
                                        trail: { stroke: '#eee' }
                                    }}
                                    strokeWidth={12}
                                    value={progress || 0}
                                />
                            )}

                            {/* Ícone de sucesso */}
                            {uploaded && !error && <MdCheckCircle size={26} color='#78e5d5' />}

                            {/* Link externo para abrir o vídeo em nova aba */}
                            {url && (
                                <a href={url} target='_blank' rel='noopener noreferrer' title="Visualizar vídeo original">
                                    <IconButton size="small" style={{ color: '#222' }}>
                                        <MdLink size={24} />
                                    </IconButton>
                                </a>
                            )}

                            {/* Ícone de erro */}
                            {error && <MdError size={26} color='#e57878' />}

                            {/* Botão de exclusão (só permite deletar se não estiver no meio de um upload) */}
                            {(!isFinite(progress) || uploaded || error) && onDelete && (
                                <IconButton
                                    size="small"
                                    onClick={() => onDelete(id)}
                                    title="Remover vídeo"
                                >
                                    <FaTrashAlt size={18} color='#e57878' />
                                </IconButton>
                            )}
                        </Box>
                    </Grid>

                </Grid>
            </Card>
        </Box>
    );
};

export default VideoPreview;